import React from 'react'
import { Link } from 'react-router-dom';
import logo from '../Images/footer-logo.png'
import { useTranslation } from 'react-i18next';
export default function Footer() {
    const { t } = useTranslation();
  return (
 <footer className="footer">
  {/* Avval bu yerda dasturchilarning shaxsiy telefon raqamlari turardi — o'rniga bo'limlarga havolalar */}
  <nav className="footer_left" aria-label="Footer">
    <Link to="/allrentadvertising">{t("nav_rent")}</Link>
    <Link to="/allpatneradvertising">{t("nav_partner")}</Link>
    {/* Asosiy menyudan footerga ko'chirilgan */}
    <Link to="/wanted">{t("nav_wanted")}</Link>
    <Link to="/maslahatlar">{t("Maslahatlar")}</Link>
    <Link to="/about">{t("about_web")}</Link>
  </nav>

  <div className="footer_center">
    <img src={logo} alt="My Ijarachi" width="200" height="48" />
  </div>

  <div className="footer_right">
    <a className="footer_domain" href="https://myijarachi.uz/">myijarachi.uz</a>
    <p>{t("footer_text")}</p>
  </div>
</footer>

  )
}
